"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var formConfig = {
  name: "roomDetails",
  fields: {
    bedRoom: {
      id: "bedRoom",
      jsonPath: "Properties[0].propertyDetails.roomDetails.bedRoom",
      type: "textfield",
      floatingLabelText: "Bed Room",
      numcols: 6,
      disabled: false,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.bedRoom", field.value));
      }
    },
    hall: {
      id: "acre",
      jsonPath: "Properties[0].propertyDetails.roomDetails.hall",
      type: "textfield",
      floatingLabelText: "Hall",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.hall", field.value));
      }
    },

    livingDining: {
      id: "livingDining",
      jsonPath: "Properties[0].propertyDetails.roomDetails.livingDining",
      type: "textfield",
      floatingLabelText: "Living Dining",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.livingDining", field.value));
      }
    },

    conference: {
      id: "conference",
      jsonPath: "Properties[0].propertyDetails.roomDetails.conference",
      type: "textfield",
      floatingLabelText: "Conference",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.conference", field.value));
      }
    },

    covered: {
      id: "covered",
      jsonPath: "Properties[0].propertyDetails.roomDetails.covered",
      type: "textfield",
      floatingLabelText: "Covered",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.covered", field.value));
      }
    },
    thakurGhar: {
      id: "thakurGhar",
      jsonPath: "Properties[0].propertyDetails.roomDetails.thakurGhar",
      type: "textfield",
      floatingLabelText: "Thakur Ghar",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.thakurGhar", field.value));
      }
    },
    bathRoom: {
      id: "bathRoom",
      jsonPath: "Properties[0].propertyDetails.roomDetails.bathRoom",
      type: "textfield",
      floatingLabelText: "Bathroom",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.bathRoom", field.value));
      }
    },
    healthClub: {
      id: "healthClub",
      jsonPath: "Properties[0].propertyDetails.roomDetails.healthClub",
      type: "textfield",
      floatingLabelText: "Health Club",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.healthClub", field.value));
      }
    },
    classRoom: {
      id: "classRoom",
      jsonPath: "Properties[0].propertyDetails.roomDetails.classRoom",
      type: "textfield",
      floatingLabelText: "Classroom",
      numcols: 6,
      formName: "roomDetails",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.classRoom", field.value));
      }
    },
    verandah: {
      id: "verandah",
      jsonPath: "Properties[0].propertyDetails.roomDetails.verandah",
      type: "textfield",
      floatingLabelText: "Verandah",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.verandah", field.value));
      }
    },

    mezzanine: {
      id: "mezzanine",
      jsonPath: "Properties[0].propertyDetails.roomDetails.mezzanine",
      type: "textfield",
      floatingLabelText: "Mezzanine",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref11) {
        var formKey = _ref11.formKey,
            field = _ref11.field,
            dispatch = _ref11.dispatch,
            state = _ref11.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.mezzanine", field.value));
      }
    },

    kitchen: {
      id: "kitchen",
      jsonPath: "Properties[0].propertyDetails.roomDetails.kitchen",
      type: "textfield",
      floatingLabelText: "Kitchen",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref12) {
        var formKey = _ref12.formKey,
            field = _ref12.field,
            dispatch = _ref12.dispatch,
            state = _ref12.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.kitchen", field.value));
      }
    },

    garrage: {
      id: "garrage",
      jsonPath: "Properties[0].propertyDetails.roomDetails.garrage",
      type: "textfield",
      floatingLabelText: "Garage",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref13) {
        var formKey = _ref13.formKey,
            field = _ref13.field,
            dispatch = _ref13.dispatch,
            state = _ref13.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.garrage", field.value));
      }
    },
    stairCase: {
      id: "stairCase",
      jsonPath: "Properties[0].propertyDetails.roomDetails.stairCase",
      type: "textfield",
      floatingLabelText: "Stair Case",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref14) {
        var formKey = _ref14.formKey,
            field = _ref14.field,
            dispatch = _ref14.dispatch,
            state = _ref14.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.stairCase", field.value));
      }
    },
    office: {
      id: "office",
      jsonPath: "Properties[0].propertyDetails.roomDetails.office",
      type: "textfield",
      floatingLabelText: "Office",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref15) {
        var formKey = _ref15.formKey,
            field = _ref15.field,
            dispatch = _ref15.dispatch,
            state = _ref15.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.office", field.value));
      }
    },
    study: {
      id: "study",
      jsonPath: "Properties[0].propertyDetails.roomDetails.study",
      type: "textfield",
      floatingLabelText: "Study",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref16) {
        var formKey = _ref16.formKey,
            field = _ref16.field,
            dispatch = _ref16.dispatch,
            state = _ref16.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.study", field.value));
      }
    },
    shed: {
      id: "shed",
      jsonPath: "Properties[0].propertyDetails.roomDetails.shed",
      type: "textfield",
      floatingLabelText: "Shed",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref17) {
        var formKey = _ref17.formKey,
            field = _ref17.field,
            dispatch = _ref17.dispatch,
            state = _ref17.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.shed", field.value));
      }
    },
    terrace: {
      id: "terrace",
      jsonPath: "Properties[0].propertyDetails.roomDetails.terrace",
      type: "textfield",
      disabled: false,
      floatingLabelText: "Terrace",
      updateDependentFields: function updateDependentFields(_ref18) {
        var formKey = _ref18.formKey,
            field = _ref18.field,
            dispatch = _ref18.dispatch,
            state = _ref18.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.terrace", field.value));
      }
    },
    shop: {
      id: "shop",
      jsonPath: "Properties[0].propertyDetails.roomDetails.shop",
      type: "textfield",
      floatingLabelText: "Shop",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref19) {
        var formKey = _ref19.formKey,
            field = _ref19.field,
            dispatch = _ref19.dispatch,
            state = _ref19.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.shop", field.value));
      }
    },
    store: {
      id: "store",
      jsonPath: "Properties[0].propertyDetails.roomDetails.store",
      type: "textfield",
      floatingLabelText: "Store",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref20) {
        var formKey = _ref20.formKey,
            field = _ref20.field,
            dispatch = _ref20.dispatch,
            state = _ref20.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.store", field.value));
      }
    },
    wallShop: {
      id: "wallShop",
      jsonPath: "Properties[0].propertyDetails.roomDetails.wallShop",
      type: "textfield",
      floatingLabelText: "Wall Shop",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref21) {
        var formKey = _ref21.formKey,
            field = _ref21.field,
            dispatch = _ref21.dispatch,
            state = _ref21.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.wallShop", field.value));
      }
    },
    swimingpool: {
      id: "swimingpool",
      jsonPath: "Properties[0].propertyDetails.roomDetails.swimingpool",
      type: "textfield",
      floatingLabelText: "Swimming Pool",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref22) {
        var formKey = _ref22.formKey,
            field = _ref22.field,
            dispatch = _ref22.dispatch,
            state = _ref22.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.swimingpool", field.value));
      }
    },
    others: {
      id: "others",
      jsonPath: "Properties[0].propertyDetails.roomDetails.others",
      type: "textarea",
      floatingLabelText: "Others",
      disabled: false,
      updateDependentFields: function updateDependentFields(_ref23) {
        var formKey = _ref23.formKey,
            field = _ref23.field,
            dispatch = _ref23.dispatch,
            state = _ref23.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].propertyDetails.roomDetails.others", field.value));
      }
    }
  },

  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/roomPropertyDetails.js
// module id = 1688
// module chunks = 1137